var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-client"}},[[_c('loading',{staticClass:"main",attrs:{"loading":_vm.loading}}),_c('router-view'),_c('vue-progress-bar',{attrs:{"id":"loading-bar"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }